import { Component, Input, forwardRef, Optional, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { TdLayoutComponent } from '../layout.component';
export class TdLayoutNavComponent {
/**
 * toolbarTitle?: string
 * 
 * Title set in toolbar.
 */
toolbarTitle: string;
/**
 * icon?: string
 * 
 * icon name to be displayed before the title
 */
icon: string;
/**
 * logo?: string
 * 
 * logo icon name to be displayed before the title.
 * If [icon] is set, then this will not be shown.
 */
logo: string;
/**
 * color?: string
 * 
 * toolbar color option: primary | accent | warn.
 * If [color] is not set, primary is used.
 */
color: string = 'primary';
/**
 * navigationRoute?: string
 * 
 * option to set the combined route for the icon, logo, and toolbarTitle.
 */
navigationRoute: string;
/**
 * Checks if there is a [TdLayoutComponent] as parent.
 * @return {?}
 */
get isMainSidenavAvailable(): boolean {
    return !!this._layout;
  }
/**
 * Checks if router was injected.
 * @return {?}
 */
get routerEnabled(): boolean {
    return !!this._router && !!this.navigationRoute;
  }
/**
 * @param {?} _layout
 * @param {?} _router
 */
constructor(
private _layout: TdLayoutComponent,
private _router: Router) {}
/**
 * @return {?}
 */
handleNavigationClick(): void {
    if (this.routerEnabled) {
      this._router.navigateByUrl(this.navigationRoute);
    }
  }
/**
 * If main sidenav is available, it will open the sidenav of the parent [TdLayoutComponent].
 * @return {?}
 */
openMainSidenav(): void {
    this._layout.open();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-layout-nav',
  styleUrls: ['./layout-nav.component.css' ],
  templateUrl: './layout-nav.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TdLayoutComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => TdLayoutComponent), ] }, ]},
{type: Router, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'toolbarTitle': [{ type: Input, args: ['toolbarTitle', ] },],
'icon': [{ type: Input, args: ['icon', ] },],
'logo': [{ type: Input, args: ['logo', ] },],
'color': [{ type: Input, args: ['color', ] },],
'navigationRoute': [{ type: Input, args: ['navigationRoute', ] },],
};
}

function TdLayoutNavComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdLayoutNavComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdLayoutNavComponent.ctorParameters;
/** @type {?} */
TdLayoutNavComponent.propDecorators;
/**
 * toolbarTitle?: string
 * 
 * Title set in toolbar.
 * @type {?}
 */
TdLayoutNavComponent.prototype.toolbarTitle;
/**
 * icon?: string
 * 
 * icon name to be displayed before the title
 * @type {?}
 */
TdLayoutNavComponent.prototype.icon;
/**
 * logo?: string
 * 
 * logo icon name to be displayed before the title.
 * If [icon] is set, then this will not be shown.
 * @type {?}
 */
TdLayoutNavComponent.prototype.logo;
/**
 * color?: string
 * 
 * toolbar color option: primary | accent | warn.
 * If [color] is not set, primary is used.
 * @type {?}
 */
TdLayoutNavComponent.prototype.color;
/**
 * navigationRoute?: string
 * 
 * option to set the combined route for the icon, logo, and toolbarTitle.
 * @type {?}
 */
TdLayoutNavComponent.prototype.navigationRoute;
/** @type {?} */
TdLayoutNavComponent.prototype._layout;
/** @type {?} */
TdLayoutNavComponent.prototype._router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
